import styled from '@emotion/styled';
import {
  gray06,
  primary,
  blue01,
  gray03,
} from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  spacing,
  fontSize,
  fontWeight,
  borderRadius,
  mediaMax,
} from 'presentations/views/styles';
import Link from 'presentations/views/components/atoms/Link';
import { SyntheticEvent } from 'react';

interface Props {
  href?: string;
  label: string;
  icon?: string;
  target?: string;
  fullWidth?: boolean;
  onClick?: (e: SyntheticEvent<HTMLAnchorElement>) => void;
  withMenu?: boolean;
  className?: string;
  isActive?: boolean;
}

export default function Component(props: Props) {
  return (
    <EventLink
      href={props.href}
      target={props.target}
      onClick={props.onClick}
      fullWidth={props.fullWidth}
      className={props.className}
      isActive={props.isActive}
    >
      {props.icon && (
        <PrefixIcon name={props.icon} fontSize="small" color="primary" />
      )}
      <EventLinkTitle>{props.label}</EventLinkTitle>
      {props.target === '_blank' && (
        <NewWindowIcon
          name="checkbox-multiple-blank-outline"
          size={fontSize(13)}
        />
      )}
      {props.withMenu && <Icon name="expand_more" size={fontSize(20)} />}
    </EventLink>
  );
}

export const EventLink = styled(Link)<{
  fullWidth?: boolean;
  isActive?: boolean;
}>`
  position: relative;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '213px')};
  height: 52px;
  border-radius: ${borderRadius()};
  background-color: ${gray06};
  color: ${primary};
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    background-color: ${blue01};
  }
  background-color: ${(props) => props.isActive && blue01};
`;
const EventLinkTitle = styled.span`
  font-size: ${fontSize(13)};
  font-weight: ${fontWeight('bold')};
`;
const PrefixIcon = styled(Icon)`
  margin-right: ${spacing(8)};
`;
const NewWindowIcon = styled(Icon)`
  position: absolute;
  right: 12px;
  color: ${gray03};
`;
